import { Injectable } from '@angular/core';
import { PageFilter } from '@common/paged-data/types/page-filter.type';
import { Page } from '@common/paged-data/types/page.type';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { DataService } from '@portal-core/data/common/services/data.service';
import { ProjectChecklistType } from '@portal-core/project-checklists/enums/project-checklist-type.enum';
import { ProjectChecklistItem } from '@portal-core/project-checklists/models/project-checklist-item.model';
import { ProjectChecklistItemsDataService } from '@portal-core/project-checklists/services/project-checklist-items/project-checklist-items-data.service';
import { ProjectChecklistsApiService } from '@portal-core/project-checklists/services/project-checklists-api.service';
import { Resettable } from '@portal-core/util/resettable.decorator';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
@Resettable()
export class ProjectChecklistItemsService extends CollectionServiceBase<ProjectChecklistItem> {

  constructor(
    private projectChecklistsItemsDataService: ProjectChecklistItemsDataService,
    private projectChecklistsApiService: ProjectChecklistsApiService,
    protected dataService: DataService
  ) {
    super(projectChecklistsItemsDataService, dataService);
  }

  getChecklistItemsGridById$(path: string, filters: PageFilter, checklistId: number, checklistType: ProjectChecklistType): Observable<Page<ProjectChecklistItem>> {
    return this.projectChecklistsApiService.getChecklistItemsGridById$(checklistId, checklistType, { Filters: filters, Path: path });
  }

  isPathInChecklist(path: string, checklistFilter: string | string[]): boolean {
    const filters = Array.isArray(checklistFilter) ? checklistFilter : (checklistFilter ?? '').split(';').filter((filter => !!filter));
    path = path ?? '';

    return filters.length === 0 || filters.some(filter => {
      return path.startsWith(filter + '/') || filter.startsWith(path);
    });
  }
}
